export const TEST = 'TEST';
export const CLEAR_CABINET_STATE = 'CLEAR_CABINET_STATE';
export const SET_SETTINGS_VERIFY_MODAL_STATUS = 'SET_SETTINGS_VERIFY_MODAL_STATUS';
export const SET_SETTINGS_ADD_WALLET_MODAL_STATUS = 'SET_SETTINGS_ADD_WALLET_MODAL_STATUS';
export const SET_SETTINGS_EDIT_WALLET_MODAL_STATUS = 'SET_SETTINGS_EDIT_WALLET_MODAL_STATUS';
export const SET_SETTINGS_ALLOCATION_DETAILS_MODAL_STATUS = 'SET_SETTINGS_ALLOCATION_DETAILS_MODAL_STATUS';
export const SET_FREEZE_OMT_HONEE_MODAL_STATUS = 'SET_FREEZE_OMT_HONEE_MODAL_STATUS';
export const SET_EXTEND_FREEZE_MODAL_STATUS = 'SET_EXTEND_FREEZE_MODAL_STATUS';
export const SET_STAKE_MODAL_STATUS = 'SET_STAKE_MODAL_STATUS';
export const SET_ALLOCATION_MODAL_STATUS = 'SET_ALLOCATION_MODAL_STATUS';
export const CLEAR_VERIFY_EMAIL_ERROR = 'CLEAR_VERIFY_EMAIL_ERROR';



export const GET_PROJECTS_ALL_STARTED = 'GET_PROJECTS_ALL_STARTED';
export const GET_PROJECTS_ALL_SUCCESS = 'GET_PROJECTS_ALL_SUCCESS';
export const GET_PROJECTS_ALL_FAILURE = 'GET_PROJECTS_ALL_FAILURE';

export const GET_PROJECTS_LAST_STARTED = 'GET_PROJECTS_LAST_STARTED';
export const GET_PROJECTS_LAST_SUCCESS = 'GET_PROJECTS_LAST_SUCCESS';
export const GET_PROJECTS_LAST_FAILURE = 'GET_PROJECTS_LAST_FAILURE';

export const GET_PROJECT_STARTED = 'GET_PROJECT_STARTED';
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export const GET_PROJECT_FAILURE = 'GET_PROJECT_FAILURE';

export const GET_USER_DATA_STARTED = 'GET_USER_DATA_STARTED';
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const GET_USER_DATA_FAILURE = 'GET_USER_DATA_FAILURE';

export const SET_USER_NAME_STARTED = 'SET_USER_NAME_STARTED';
export const SET_USER_NAME_SUCCESS = 'SET_USER_NAME_SUCCESS';
export const SET_USER_NAME_FAILURE = 'SET_USER_NAME_FAILURE';

export const DISCONNECT_USER_STARTED = 'DISCONNECT_USER_STARTED';
export const DISCONNECT_USER_SUCCESS = 'DISCONNECT_USER_SUCCESS';
export const DISCONNECT_USER_FAILURE = 'DISCONNECT_USER_FAILURE';

export const GET_LAUNCHPAD_STATUSES_STARTED = 'GET_LAUNCHPAD_STATUSES_STARTED';
export const GET_LAUNCHPAD_STATUSES_SUCCESS = 'GET_LAUNCHPAD_STATUSES_SUCCESS';
export const GET_LAUNCHPAD_STATUSES_FAILURE = 'GET_LAUNCHPAD_STATUSES_FAILURE';

export const CHANGE_USER_NAME_STARTED = 'CHANGE_USER_NAME_STARTED';
export const CHANGE_USER_NAME_SUCCESS = 'CHANGE_USER_NAME_SUCCESS';
export const CHANGE_USER_NAME_FAILURE = 'CHANGE_USER_NAME_FAILURE';

export const CHANGE_USER_AVATAR_STARTED = 'CHANGE_USER_AVATAR_STARTED';
export const CHANGE_USER_AVATAR_SUCCESS = 'CHANGE_USER_AVATAR_SUCCESS';
export const CHANGE_USER_AVATAR_FAILURE = 'CHANGE_USER_AVATAR_FAILURE';

export const GET_USER_PROJECTS_STARTED = 'GET_USER_PROJECTS_STARTED';
export const GET_USER_PROJECTS_SUCCESS = 'GET_USER_PROJECTS_SUCCESS';
export const GET_USER_PROJECTS_FAILURE = 'GET_USER_PROJECTS_FAILURE';

export const CHANGE_USER_EMAIL_STARTED = 'CHANGE_USER_EMAIL_STARTED';
export const CHANGE_USER_EMAIL_SUCCESS = 'CHANGE_USER_EMAIL_SUCCESS';
export const CHANGE_USER_EMAIL_FAILURE = 'CHANGE_USER_EMAIL_FAILURE';

export const RESEND_VERIFY_CODE_STARTED = 'RESEND_VERIFY_CODE_STARTED';
export const RESEND_VERIFY_CODE_SUCCESS = 'RESEND_VERIFY_CODE_SUCCESS';
export const RESEND_VERIFY_CODE_FAILURE = 'RESEND_VERIFY_CODE_FAILURE';

export const VERIFY_USER_EMAIL_STARTED = 'VERIFY_USER_EMAIL_STARTED';
export const VERIFY_USER_EMAIL_SUCCESS = 'VERIFY_USER_EMAIL_SUCCESS';
export const VERIFY_USER_EMAIL_FAILURE = 'VERIFY_USER_EMAIL_FAILURE';

export const GET_USER_ADDED_WALLETS_STARTED = 'GET_USER_ADDED_WALLETS_STARTED';
export const GET_USER_ADDED_WALLETS_SUCCESS = 'GET_USER_ADDED_WALLETS_SUCCESS';
export const GET_USER_ADDED_WALLETS_FAILURE = 'GET_USER_ADDED_WALLETS_FAILURE';

export const GET_WALLETS_NETWORKS_STARTED = 'GET_WALLETS_NETWORKS_STARTED';
export const GET_WALLETS_NETWORKS_SUCCESS = 'GET_WALLETS_NETWORKS_SUCCESS';
export const GET_WALLETS_NETWORKS_FAILURE = 'GET_WALLETS_NETWORKS_FAILURE';

export const ADD_WALLET_STARTED = 'ADD_WALLET_STARTED';
export const ADD_WALLET_SUCCESS = 'ADD_WALLET_SUCCESS';
export const ADD_WALLET_FAILURE = 'ADD_WALLET_FAILURE';

export const EDIT_WALLET_STARTED = 'EDIT_WALLET_STARTED';
export const EDIT_WALLET_SUCCESS = 'EDIT_WALLET_SUCCESS';
export const EDIT_WALLET_FAILURE = 'EDIT_WALLET_FAILURE';

export const GET_TOKEN_FREEZE_DATA_STARTED = 'GET_TOKEN_FREEZE_DATA_STARTED';
export const GET_TOKEN_FREEZE_DATA_SUCCESS = 'GET_TOKEN_FREEZE_DATA_SUCCESS';
export const GET_TOKEN_FREEZE_DATA_FAILURE = 'GET_TOKEN_FREEZE_DATA_FAILURE';

export const FREEZE_OMT_WITH_HONEE_STARTED = 'FREEZE_OMT_WITH_HONEE_STARTED';
export const FREEZE_OMT_WITH_HONEE_SUCCESS = 'FREEZE_OMT_WITH_HONEE_SUCCESS';
export const FREEZE_OMT_WITH_HONEE_FAILURE = 'FREEZE_OMT_WITH_HONEE_FAILURE';

export const GET_FREEZE_HISTORY_STARTED = 'GET_FREEZE_HISTORY_STARTED';
export const GET_FREEZE_HISTORY_SUCCESS = 'GET_FREEZE_HISTORY_SUCCESS';
export const GET_FREEZE_HISTORY_FAILURE = 'GET_FREEZE_HISTORY_FAILURE';

export const EXTEND_FREEZE_STARTED = 'EXTEND_FREEZE_STARTED';
export const EXTEND_FREEZE_SUCCESS = 'EXTEND_FREEZE_SUCCESS';
export const EXTEND_FREEZE_FAILURE = 'EXTEND_FREEZE_FAILURE';

export const CLOSE_FREEZE_STARTED = 'CLOSE_FREEZE_STARTED';
export const CLOSE_FREEZE_SUCCESS = 'CLOSE_FREEZE_SUCCESS';
export const CLOSE_FREEZE_FAILURE = 'CLOSE_FREEZE_FAILURE';

export const JOIN_PROJECT_STARTED = 'JOIN_PROJECT_STARTED';
export const JOIN_PROJECT_SUCCESS = 'JOIN_PROJECT_SUCCESS';
export const JOIN_PROJECT_FAILURE = 'JOIN_PROJECT_FAILURE';

export const GET_LAUNCHPAD_MAIN_STARTED = 'GET_LAUNCHPAD_MAIN_STARTED';
export const GET_LAUNCHPAD_MAIN_SUCCESS = 'GET_LAUNCHPAD_MAIN_SUCCESS';
export const GET_LAUNCHPAD_MAIN_FAILURE = 'GET_LAUNCHPAD_MAIN_FAILURE';

export const SET_ALLOCATION_HONEE_INVEST_STARTED = 'SET_ALLOCATION_HONEE_INVEST_STARTED';
export const SET_ALLOCATION_HONEE_INVEST_SUCCESS = 'SET_ALLOCATION_HONEE_INVEST_SUCCESS';
export const SET_ALLOCATION_HONEE_INVEST_FAILURE = 'SET_ALLOCATION_HONEE_INVEST_FAILURE';

export const SET_ALLOCATION_QR_INVEST_STARTED = 'SET_ALLOCATION_QR_INVEST_STARTED';
export const SET_ALLOCATION_QR_INVEST_SUCCESS = 'SET_ALLOCATION_QR_INVEST_SUCCESS';
export const SET_ALLOCATION_QR_INVEST_FAILURE = 'SET_ALLOCATION_QR_INVEST_FAILURE';

export const GET_USER_ALLOCATION_STARTED = 'GET_USER_ALLOCATION_STARTED';
export const GET_USER_ALLOCATION_SUCCESS = 'GET_USER_ALLOCATION_SUCCESS';
export const GET_USER_ALLOCATION_FAILURE = 'GET_USER_ALLOCATION_FAILURE';

export const SET_ALLOCATION_HASH_STARTED = 'SET_ALLOCATION_HASH_STARTED';
export const SET_ALLOCATION_HASH_SUCCESS = 'SET_ALLOCATION_HASH_SUCCESS';
export const SET_ALLOCATION_HASH_FAILURE = 'SET_ALLOCATION_HASH_FAILURE';

export const GET_ALLOCATION_VESTING_DETAILS_STARTED = 'GET_ALLOCATION_VESTING_DETAILS_STARTED';
export const GET_ALLOCATION_VESTING_DETAILS_SUCCESS = 'GET_ALLOCATION_VESTING_DETAILS_SUCCESS';
export const GET_ALLOCATION_VESTING_DETAILS_FAILURE = 'GET_ALLOCATION_VESTING_DETAILS_FAILURE';

export const CHECK_ACADEMY_STARTED = 'CHECK_ACADEMY_STARTED';
export const CHECK_ACADEMY_SUCCESS = 'CHECK_ACADEMY_SUCCESS';
export const CHECK_ACADEMY_FAILURE = 'CHECK_ACADEMY_FAILURE';

export const WALLET_TRANSACTION_CHECK_STARTED = 'WALLET_TRANSACTION_CHECK_STARTED';
export const WALLET_TRANSACTION_CHECK_SUCCESS = 'WALLET_TRANSACTION_CHECK_SUCCESS';
export const WALLET_TRANSACTION_CHECK_FAILURE = 'WALLET_TRANSACTION_CHECK_FAILURE';

export const GET_PREVIEW_PROJECT_STARTED = 'GET_PREVIEW_PROJECT_STARTED';
export const GET_PREVIEW_PROJECT_SUCCESS = 'GET_PREVIEW_PROJECT_SUCCESS';
export const GET_PREVIEW_PROJECT_FAILURE = 'GET_PREVIEW_PROJECT_FAILURE';

